import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { App } from './App';
import { CorporatePage } from './pages/CorporatePage';
import { InfluencersPage } from './pages/InfluencersPage';
import { PoliticiansPage } from './pages/PoliticiansPage';
import { BlueprintPage } from './pages/BlueprintPage';
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
export function AppRouter() {
  return <BrowserRouter data-id="element-44">
      <ScrollToTop data-id="element-45" />
      <Routes data-id="element-46">
        <Route path="/" element={<App data-id="element-48" />} data-id="element-47" />
        <Route path="/corporate" element={<CorporatePage data-id="element-50" />} data-id="element-49" />
        <Route path="/influencers" element={<InfluencersPage data-id="element-52" />} data-id="element-51" />
        <Route path="/politicians" element={<PoliticiansPage data-id="element-54" />} data-id="element-53" />
        <Route path="/blueprint" element={<BlueprintPage data-id="element-56" />} data-id="element-55" />
      </Routes>
    </BrowserRouter>;
}